if ($('.js-dropdown-modal-open').length) {
    App.D.on('click', '.js-dropdown-modal-open', function() {
        $(this).siblings('.js-dropdown-modal').toggleClass('_opened');
        $(this).toggleClass('dropdown-modal--opened');
    });

    App.D.on('click', '.js-dropdown-modal-close', function() {
        $(this).closest('.js-dropdown-modal').removeClass('_opened');
        $(this).removeClass('dropdown-modal--opened');
    });
}

App.D.on('click', '.js-dropdown-modal', function(e) {
    if ($(this).hasClass('header__login-dropdown') && !$(e.target).parents().addBack().is('.header__login-links')) {
        $(this).removeClass('_opened');
        $('.js-dropdown-modal-open').removeClass('dropdown-modal--opened');
    }
});

App.H.on('click', function(e) {
    if (!$(e.target).parents().addBack().is('.js-dropdown-modal._opened') && !$(e.target).parents().addBack().is('.js-dropdown-modal-open')) {
        $('.js-dropdown-modal').removeClass('_opened');
        $('.js-dropdown-modal-open').removeClass('dropdown-modal--opened');
    }
});
